/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerRequirementsFormTrailerTypesField: "trailer-requirements-form-trailer-types-field",
  // data-testid for the visible Select trigger.
  trailerRequirementsFormTrailerTypesSelector: "trailer-requirements-form-trailer-types-selector",
  trailerRequirementsFormOwnedTrailerTypeOption: "trailer-requirements-form-owned-trailer-type-option",
  trailerRequirementsFormOtherTrailerTypeOption: "trailer-requirements-form-other-trailer-type-option",
  trailerRequirementsFormOrderTypeField: "trailer-requirements-form-order-type-field",
  trailerRequirementsFormOrderTypeSelector: "trailer-requirements-form-order-type-selector",
  trailerRequirementsFormLoadTypeOption: "trailer-requirements-form-load-type-option",
  trailerRequirementsFormTemperatureSensitiveSelector: "trailer-requirements-form-temperature-sensitive-selector",
  trailerRequirementsFormTemperatureSensitiveYes: "trailer-requirements-form-temperature-sensitive-yes",
  trailerRequirementsFormTemperatureSensitiveNo: "trailer-requirements-form-temperature-sensitive-no",
  trailerRequirementsFormMinTemperatureWithUnit: "trailer-requirements-form-min-temperature-with-unit",
  trailerRequirementsFormMaxTemperatureWithUnit: "trailer-requirements-form-max-temperature-with-unit",
} as const;
